import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import * as styles from "./Accordion-tw-styles"
import AccordionItem from "./AccordionItem"
import Button from "../../../../UI/Button/Button"
import { SEARCH_FIELD } from "../../../../../constants/label.constants"
import { getStockDetails } from "../../../../../service/StockService"
import { searchJobGtm } from "../../../../../constants/gtm.constants"

const Accordion = props => {
  const [clicked, setClicked] = useState("")
  const [active, setActive] = useState(false)
  const [isFieldExpanded, setIsFieldExpanded] = useState(false)
  const { collection } = props
  const [stockDetails, setStockDetails] = useState([])
  const [searchTerm, setSearchTerm] = useState("")
  let queryParams = ""
  const style = styles["defaultStyle"]
  const handleToggle = index => {
    if (clicked === index) {
      setClicked("")
      setActive(prev => !prev)
    } else {
      setClicked(index)
      setActive(true)
    }
  }

  const handleSearch = e => {
    setSearchTerm(e.target.value)
  }

  const handleSearchSubmit = () => {
    queryParams = `${SEARCH_FIELD.link}` + searchTerm
    if (window?.dataLayer) {
      searchJobGtm.GAeventLabel = searchTerm
      searchJobGtm.GAeventCategory = "searchHeader"
      window.dataLayer.push({ ...searchJobGtm })
    }
    history.pushState({}, "", queryParams)
    location.reload()
  }

  const onKeyDown = e => {
    if (e.key === "Enter" && searchTerm) {
      handleSearchSubmit()
    }
  }

  useEffect(() => {
    async function fetchData() {
      let data = await getStockDetails()
      setStockDetails(data)
    }
    fetchData()
  }, [])

  return (
    <>
      <div
        role="navigation"
        className="TopINMAinParent flex items-center flex-wrap m-0 h-[50px]  pb-[10px] lg:mx-auto justify-between relative  w-full  lg:max-w-lg xl:max-w-xl xl:w-full lg:px-[15px] items-center"
      >
        <div className={style?.stockTicker}>
          {stockDetails?.length > 0 && (
            <p>
              {stockDetails[0]?.exchange}: {stockDetails[0]?.symbol} $
              {stockDetails[0]?.lastTrade} USD{" "}
              {stockDetails[0]?.changeNumber == 0
                ? stockDetails[0]?.changeNumber
                : stockDetails[0]?.changeNumber.toFixed(2)}{" "}
              (
              {stockDetails[0]?.changePercent == 0
                ? stockDetails[0]?.changePercent
                : stockDetails[0]?.changePercent.toFixed(2)}
              %)
            </p>
          )}
        </div>
        <div className={style?.TopNavMainWrap}>
          <ul className={style?.TopNavWrap}>
            {collection.map((item, index) => (
              <AccordionItem
                onToggle={() => handleToggle(index)}
                clicked={clicked}
                setClicked={setClicked}
                index={index}
                active={active}
                setActive={setActive}
                key={index}
                item={item}
              />
            ))}
            <li
              className={
                isFieldExpanded
                  ? `${style?.searchToggle} activeSearch`
                  : `${style?.searchToggle}`
              }
            >
              <Button
                className={`
                  !isFieldExpanded ? "icon-search" : "icon-right-arrow"
                `}
                role="button"
                ariaLabel={SEARCH_FIELD.ariaLabel1}
                onClick={() => setIsFieldExpanded(!isFieldExpanded)}
              ></Button>
            </li>
          </ul>
        </div>
      </div>

      <div
        className={
          isFieldExpanded ? `${style?.searchBar} active` : `${style?.searchBar}`
        }
        role="search"
      >
        <div className={style?.searchBarContainer}>
          <div className={style?.colofSearch}>
            <input
              id="accordion_search"
              type="text"
              placeholder={SEARCH_FIELD.placeholder}
              aria-label={SEARCH_FIELD.ariaLabel2}
              value={searchTerm}
              onChange={handleSearch}
              onKeyDown={onKeyDown}
              data-testid="accordion_search"
            />
            <Button
              type="button"
              ariaLabel={SEARCH_FIELD.ariaLabel3}
              className={style?.searchButton}
              onClick={handleSearchSubmit}
              data-testid="accordion_button"
            ></Button>
          </div>
        </div>
      </div>
    </>
  )
}

Accordion.propTypes = {
  collection: PropTypes.array,
}

export default Accordion
